import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";

interface InstructionsProps {
    instructions: string;
    instructionsExpanded: boolean;
    setInstructionsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Instructions(props: InstructionsProps) {
    return <ExpansionPanel title={"Instructions"} style={{ marginBottom: '10px' }} expanded={props.instructionsExpanded} onAction={(event) => props.setInstructionsExpanded(!event.expanded)} tabIndex={0}>
            {props.instructionsExpanded && (
                <ExpansionPanelContent>
                    {props.instructions}
                </ExpansionPanelContent>
            )}
    </ExpansionPanel>;
}